module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"confirm":"確認"}}')
  delete Component.options._Ctor
}
